import * as _ from "lodash";
import MaskUtil from "core-ui/client/src/app/MaskUtil";
import ExternalLogger from "core-ui/client/src/app/ExternalLogger";
import DateUtil from "core-ui/client/src/app/DateUtil";
import beneficiaryTypeCodes from "../../../../common/constants/beneficiaryTypeCodes";
import beneficiaryDesignationCodes from "../../../../common/constants/beneficiaryDesignationCodes";
import beneficiaryRelationshipCodes from "../../../../common/constants/beneficiaryRelationshipCodes";
import beneficiaryMaritalStatuses from "../../../../common/constants/beneficiaryMaritalStatuses";
import beneficiaryPageEvents from "../../../../common/constants/beneficiaryPageEvents";
import beneficiaryActionStates from "../../../../common/constants/beneficiaryStates";

/**
 * This is a separate controller for the form view that allows us to isolate the
 * form logic from other views.
 *
 * @param $scope
 * @param $injector
 */
function BeneficiaryFormController(
    $scope,
    $timeout,
    beneficiaryService,
    dataService,
    formService,
    $translate,
    participantService,
    eventBus
) {
    // ViewModel replaces $scope
    var vm = this;
    var logger = ExternalLogger.getInstance("BeneficiaryController");

    var stateZipValidity;
    //
    // Translation Strings
    vm.translate = {
        buttonSave: "",
        buttonDelete: "",
        useAddressTip: ""
    };

    $scope.useAddressTip = $translate.instant(
        "app.beneficiary.beneficiaryForm.labels.useAddressOnFile.tooltip",
        vm.translate
    );
    $scope.isWF = window.accu === "WellsFargo";
    $scope.maritalTouched = false;
    //
    // Input mask config
    $scope.cleaveoptions = {
        ssn: {
            blocks: [3, 2, 4],
            delimiters: ["-"]
        },
        tin: {
            blocks: [2, 7],
            delimiters: ["-"]
        }
    };

    $scope.focusInput = function (event) {
        var method = "focusInput()";
        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);
        //event.currentTarget.type = "text";
        $timeout(function () {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }, 500);
    };

    $scope.handleFocusInput = function (event) {
        event.currentTarget.type = "text";
    };

    $scope.handleBlurInput = function (event) {
        event.currentTarget.type = "password";
    };

    /**
     * allocationChanged works on ng-blur because its running validations but
     * changesMade runs on actual ng-change.
     */
    vm.changesMade = function () {
        beneficiaryService.setShowSaveDialog(true);
    };

    processTranslations();

    function processTranslations() {
        $translate("app.beneficiary.buttons.save").then(function (translation) {
            vm.translate.buttonSave = translation;
        });

        $translate("app.beneficiary.buttons.delete").then(function (translation) {
            vm.translate.buttonDelete = translation;
        });

        $translate("app.beneficiary.beneficiaryForm.labels.useAddressOnFile.tooltip").then(
            function (translation) {
                vm.translate.useAddressTip = translation;
            }
        );
    }

    //
    // Error messages
    vm.errors = [];
    vm.invalidSelection = false;

    // Get code values
    vm.beneficiaryTypeCodes = beneficiaryTypeCodes;
    vm.beneficiaryDesignationCodes = beneficiaryDesignationCodes;
    vm.beneficiaryRelationshipCodes = beneficiaryRelationshipCodes;
    vm.maritalStatuses = beneficiaryMaritalStatuses;
    vm.initalMaritalStatus = $scope.data.maritalStatus;
    vm.showMaritalStatErr = true;

    $scope.setFormFields = function (dirty) {
        var fields = [
            "maritalStatus",
            "beneficiaryName",
            "beneficiaryLastName",
            "beneficiaryFirstName",
            "beneficiaryMiddleName",
            "beneficiarySuffix",
            "relationship",
            "socialSecurityNumber",
            "dateOfBirth",
            "dateOfTrust",
            "taxIdentificationNumber",
            "phoneNumber"
        ];

        var addressFields = ["address1", "address2", "city", "state", "zipCode", "country"];

        if (
            !document
                .querySelector("#beneficiary-designation-section")
                .classList.contains("ng-hide")
        ) {
            fields.push("beneficiaryDesignation");
        }

        if (!document.querySelector("#beneficiary-type-section").classList.contains("ng-hide")) {
            fields.push("beneficiaryType");
        }

        if ($scope.data.beneficiaryAddressRequired) {
            fields = fields.concat(addressFields);
        }

        var valid = true;

        //
        // Loop through each field for the beneficiary and check if it is valid.
        // If not valid, flag the field as dirty because Angular will not check
        // validation until the form is submitted.
        angular.forEach(fields, function (fieldName) {
            if ($scope.beneficiaryForm.hasOwnProperty(fieldName)) {
                if (dirty && !$scope.beneficiaryForm[fieldName].$valid) {
                    valid = false;
                }

                $scope.data.dataChanged = true;
                $scope.beneficiaryForm[fieldName].$dirty = dirty;
            }
        });

        return valid;
    };

    /**
     * Cancel editing the beneficiary
     */
    vm.cancel = function () {
        logger.info("Cancel clicked.");
        $scope.data.maritalStatus = vm.initalMaritalStatus;
        // Get the original beneficiary record
        var record = beneficiaryService.getRecord($scope.beneficiary.id);

        if (record !== null) {
            // Revert the beneficiary fields to their original values
            for (var property in record) {
                if (record.hasOwnProperty(property)) {
                    $scope.beneficiary[property] = record[property];
                }
            }
        }

        eventBus.dispatch(beneficiaryPageEvents.EDIT_PAGE_CANCEL, this);

        // If QJSA verification is required and there are no beneficiaries on file, the Cancel button
        // should redirect to one of two places depending on whether we are in My Account or Enrollment:
        // 1. If in My Account, return to the previous page.
        // 2. If coming from Enrollment, redirect to LIAT/My Accounts.
        if (
            $scope.data.qjsaVerificationRequired &&
            $scope.data.beneficiaries.Primary.length === 0 &&
            $scope.data.beneficiaries.Contingent.length === 0
        ) {
            var $location = $injector.get("$location");
            var fromUrl = beneficiaryService.getFromUrl();

            if (fromUrl && fromUrl.indexOf("/enroll/#/") === -1) {
                logger.debug("cancel() redirecting to {0}", [fromUrl]);

                $location.url(fromUrl);
            } else {
                // Participant came to beneficiaries from enrollment. Redirect to LIAT/Account Overview
                var $state = $injector.get("$state");
                var accountHomeStateName = "landing";

                logger.debug('cancel() transitioning to state "{0}"', [accountHomeStateName]);

                $state.go(accountHomeStateName);
            }
        } else {
            // This will be the more common case
            $scope.navigateToList();
        }
    };

    /**
     * Submit the form
     *
     * @param valid
     */
    vm.submit = function (valid) {
        // Trigger validation for marital status if it is shown on the form
        if ($scope.beneficiaryForm.hasOwnProperty("maritalStatus")) {
            $scope.beneficiaryForm.maritalStatus.$dirty = true;
        }

        // Check if the beneficiary has been flagged for deletion but not
        // confirmed
        if ($scope.beneficiary.beneficiaryState === $scope.data.beneficiaryStates.removed) {
            // Remove the beneficiary from the scope
            if (
                $scope.beneficiary.beneficiaryDesignation === vm.beneficiaryDesignationCodes.Primary
            ) {
                vm.removeBeneficiaryFromList("Primary", $scope.beneficiary);
            } else {
                vm.removeBeneficiaryFromList("Contingent", $scope.beneficiary);
            }
        }

        if (valid) {
            vm.removeSaveErrors();
            $scope.constructUIDetails();
            $scope.setFormFields(false);

            vm.splitAllocations();

            eventBus.dispatch(beneficiaryPageEvents.EDIT_PAGE_CONTINUE, this);
            $scope.navigateToList();
        }
    };

    /**
     * Split allocations evenly across all new beneficiaries as they are added.
     * This feature is enabled via the autoAllocations flag.
     *
     *
     */
    vm.splitAllocations = function () {
        if (!$scope.data.autoAllocations) {
            return;
        }

        var allocation, numBeneficiaries;
        var beneKeys = ["Primary", "Contingent"];

        angular.forEach(beneKeys, function (key) {
            numBeneficiaries = $scope.data.beneficiaries[key].length;
            allocation = numBeneficiaries > 0 ? Math.floor(10000 / numBeneficiaries) / 100 : 0;

            angular.forEach($scope.data.beneficiaries[key], function (beneficiary, index) {
                if (index === 0) {
                    // Add the remainder to the first beneficiary
                    beneficiary.allocationPercent =
                        Math.round(100 * (allocation + (100 - allocation * numBeneficiaries))) /
                        100;
                } else {
                    beneficiary.allocationPercent = allocation;
                }
            });
        });
    };

    vm.isDateofTrustRequired = function () {
        return beneficiaryService.getType($scope.beneficiary) === vm.beneficiaryTypeCodes.Trust;
    };

    vm.showDateofTrustField = function (beneficiary) {
        var method = "showDateofTrustField()";
        var rc = true;
        if (
            beneficiaryService.getType(beneficiary) === vm.beneficiaryTypeCodes.Other ||
            beneficiaryService.getType(beneficiary) === vm.beneficiaryTypeCodes.Estate
        ) {
            rc = false;
        }
        logger.debug("{0} - returning [{1}]", [method, JSON.stringify(rc)]);
        return rc;
    };

    /**
     * Called when the marital status radio is changed.
     *
     * We need to disable the "Spouse" option in the Beneficiary Type drop-down
     * if the participant chooses "Single".
     */
    vm.maritalStatusChanged = function (e, newMaritalCode) {
        var method = "maritalStatusChanged()";
        var enableSpouseRelationship = true;
        vm.showMaritalStatErr = true;

        logger.debug("{0} - marital status changed.  maritalStatus=[{1}], error={2}", [
            method,
            $scope.data && $scope.data.maritalStatus
                ? JSON.stringify($scope.data.maritalStatus)
                : "null",
            $scope.beneficiaryForm.maritalStatus.$error
                ? JSON.stringify($scope.beneficiaryForm.maritalStatus.$error)
                : "null"
        ]);

        if (
            (!vm.disableMaritalStatus() && $scope.data.initialMaritalStatus) ||
            (vm.disableMaritalStatus() &&
                $scope.data.maritalStatus === beneficiaryMaritalStatuses.Single &&
                beneficiaryService.getRelationship($scope.beneficiary) ===
                    beneficiaryRelationshipCodes.Spouse)
        ) {
            if (e !== undefined && newMaritalCode !== $scope.data.initialMaritalStatus) {
                $scope.maritalTouched = true;
            }

            $scope.data.maritalStatus = $scope.data.initialMaritalStatus;
            participantService.setMaritalStatus($scope.data.initialMaritalStatus);
            return;
        } else {
            $scope.data.maritalStatus = newMaritalCode;
        }

        if ($scope.beneficiary.beneficiaryType === "") {
            vm.showMaritalStatErr = false;
        }

        if ($scope.data.maritalStatus != beneficiaryMaritalStatuses.Married) {
            enableSpouseRelationship = false;

            logger.debug("{0} - changed to single", [method]);

            if (
                beneficiaryService.getRelationship($scope.beneficiary) ==
                beneficiaryRelationshipCodes.Spouse
            ) {
                if ($scope.beneficiary.id) {
                    $scope.data.maritalStatus = "M";
                    participantService.setMaritalStatus($scope.data.maritalStatus);
                } else {
                    $scope.beneficiary.beneficiaryType = "";
                    vm.showMaritalStatErr = false;
                    logger.debug("{0} - unsetting marital status", [method]);
                }
            }
        }
        vm.changesMade();
        participantService.setMaritalStatus($scope.data.maritalStatus);
        $scope.enableSpouseRelationship(enableSpouseRelationship);
    };

    /**
     * Called when the beneficiary type is selected/changed, to determine if the
     * beneficiary type of individual:spouse (IND:SPS) should be disabled, due
     * to the part being not married. Not married vs single will allow for
     * entries in the future like widowed or divorced
     *
     * We need to disable the "Spouse" option in the Beneficiary Type drop-down
     * if the participant is "Single".
     */
    vm.spouseRelationshipVerification = function () {
        // Disable the Spouse option in the relationship dropdown if the
        // beneficiary is single
        if ($scope.data.maritalStatus != vm.maritalStatuses.Married) {
            /*
             * ===
             * maritalStatuses.Single ) {
             */
            $scope.enableSpouseRelationship(false);
        } else {
            $scope.enableSpouseRelationship(true);
        }
    };

    /**
     * Called when the beneficiary type is selected/changed, to determine if the
     * beneficiary type of individual:spouse (IND:SPS) should be disabled, if
     * we have primary ben as spouse then disable the "Spouse" option
     * in the Beneficiary Type drop-down
     */

    vm.primaryBenSpouseVerification = function () {
        // Disable the Spouse option in the relationship dropdown if the
        // primary beneficiary is having spouse
        /*if(beneficiaryService.getRelationship($scope.data.beneficiaries.Primary[0]) == vm.beneficiaryRelationshipCodes.Spouse){
            $scope.enableSpouseRelationship(false);
            $scope.enableDomesticPartnerRelationship(false);
          }*/

        let dpIsListedAsPrimary = $scope.data.beneficiaries.Primary.find(
            (beneficiary) =>
                beneficiaryService.getRelationship(beneficiary) ===
                vm.beneficiaryRelationshipCodes.Spouse
        );
        let dpIsListedAsContingent = $scope.data.beneficiaries.Contingent.find(
            (beneficiary) =>
                beneficiaryService.getRelationship(beneficiary) ===
                vm.beneficiaryRelationshipCodes.Spouse
        );
        if (dpIsListedAsPrimary || dpIsListedAsContingent) {
            $scope.enableDomesticPartnerRelationship(false);
            $scope.enableSpouseRelationship(false);
        }
    };

    vm.primaryBenDomesticPartnerVerification = function () {
        let dpIsListedAsPrimary = $scope.data.beneficiaries.Primary.find(
            (beneficiary) =>
                beneficiaryService.getRelationship(beneficiary) ===
                vm.beneficiaryRelationshipCodes.DomesticPartner
        );
        let dpIsListedAsContingent = $scope.data.beneficiaries.Contingent.find(
            (beneficiary) =>
                beneficiaryService.getRelationship(beneficiary) ===
                vm.beneficiaryRelationshipCodes.DomesticPartner
        );

        // Disable the Domestic Partner option in the relationship dropdown if the
        // primary beneficiary has a domestic partner listed as primary or contingent
        if (dpIsListedAsPrimary || dpIsListedAsContingent) {
            $scope.enableDomesticPartnerRelationship(false);
            $scope.enableSpouseRelationship(false);
        }
    };

    /**
     * Toggle whether or not the participant would like to use the address on
     * file for the current beneficiary.
     */
    vm.toggleUseAddressOnFile = function (beneficiary) {
        if (beneficiary.useAddressOnFile) {
            var address = $scope.data.participantAddressOnFile;

            beneficiary.address1 = address.address1;
            beneficiary.address2 = address.address2;
            beneficiary.city = address.city;
            beneficiary.state = address.state;
            beneficiary.zipCode = address.zipCode;
            beneficiary.country = address.country;
        } else {
            beneficiary.address1 = null;
            beneficiary.address2 = null;
            beneficiary.city = null;
            beneficiary.state = null;
            beneficiary.zipCode = null;
            // beneficiary.country=null;, We cant nullify this as this was cauing the mix up with state drodpwn coming. As the population of the state drop down comes with the model of the country value
        }
    };

    /**
     * returns true if the address should show in 'view-only' mode.
     */
    vm.showViewOnlyAddress = function (beneficiary) {
        if (!beneficiary) return false;
        if (beneficiaryService.getType(beneficiary) === vm.beneficiaryTypeCodes.Trust) {
            return false;
        }
        /*
         if (
                 (beneficiary.address1 && beneficiary.address1 !== '')
              || (beneficiary.address2 && beneficiary.address2 !== '')
              || (beneficiary.city && beneficiary.city !== '')
              || (beneficiary.state && beneficiary.state !== '')
              || (beneficiary.zipCode && beneficiary.zipCode !== '')
              || (beneficiary.country && beneficiary.country !== '')
            ){
               return true;
        }
        */
        return true;
    };

    /**
     * Get the text for the primary action button. This will change when the
     * delete checkbox is toggled to notify the participant whether they are
     * saving or deleting the beneficiary.
     *
     * @param state
     * @returns {string}
     */
    vm.getButtonText = function (state) {
        var buttonText = "";

        switch (state) {
            case $scope.data.beneficiaryStates.flaggedForRemoval:
            case $scope.data.beneficiaryStates.removed:
                buttonText = vm.translate.buttonDelete;
                break;

            default:
                buttonText = vm.translate.buttonSave;
                break;
        }

        return buttonText;
    };

    /**
     * returns true if bene DOB is masked.
     */
    vm.isDOBMasked = function (beneficiary) {
        return beneficiary && MaskUtil.isMasked(beneficiary.dateOfBirth);
    };

    /**
     * returns true if bene ssn is 'masked'.
     */
    vm.isSSNMasked = function (beneficiary) {
        return beneficiary && MaskUtil.isMasked(beneficiary.socialSecurityNumber);
    };

    /**
     * Toggle DOB from click..
     */
    vm.toggleDOBfromClick = function (beneficiary, event) {
        var method = "toggleDOBfromClick()";
        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);
        if (!event) {
            logger.debug("{0} - no event.", [method]);
            return;
        }
        if (event.type === "touchend") {
            logger.debug("{0} - ignoring superfluous 'touchend'.", [method]);
            return;
        }
        $scope.focusInput(event);
        if (
            beneficiary &&
            beneficiaryService.getType(beneficiary) == vm.beneficiaryTypeCodes.Individual
        ) {
            var dateOfBirth = $scope.beneficiaryForm.dateOfBirth.$viewValue;

            //preserve the value
            if (
                $scope.data.beneficiaryDOBRequired &&
                (MaskUtil.isMasked(beneficiary.dateOfBirth) ||
                    $scope.beneficiaryForm.dateOfBirth.$valid)
            ) {
                //make a copy
                beneficiary.previousDOB = dateOfBirth;
                beneficiary.dateOfBirth = "";
            }
        }
    };

    /**
     * Toggle DOB from mask..
     * (if dob is masked and a non-navigation key is selected,)
     */
    vm.toggleDatefromKeyDown = function (beneficiary, inputName, event) {
        const type = beneficiaryService?.getType(beneficiary);
        if (
            (type == vm.beneficiaryTypeCodes.Individual && inputName === "dateOfBirth") ||
            (type == vm.beneficiaryTypeCodes.Trust && inputName === "dateOfTrust")
        ) {
            var dateInput = $scope.beneficiaryForm[inputName].$viewValue;
            if (!vm.isNavigationKey(event.keyCode)) {
                var charCode = String.fromCharCode(event.keyCode);
                //preserve the value
                if (
                    MaskUtil.isMasked(beneficiary.dateOfBirth) ||
                    $scope.beneficiaryForm[inputName].$valid
                ) {
                    //make a copy
                    $scope.previousDateValue = dateInput;
                    beneficiary.dateOfBirth = _.isNumber(charCode) ? charCode : "";
                }
            }
        }
    };

    vm.handleMaskDate = function (beneficiary, inputName, event) {
        var method = "handleMaskDOB()";
        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);
        if (
            beneficiary &&
            (beneficiaryService.getType(beneficiary) == vm.beneficiaryTypeCodes.Individual ||
                beneficiaryService.getType(beneficiary) == vm.beneficiaryTypeCodes.Trust)
        ) {
            var dateValue = $scope.beneficiaryForm[inputName].$viewValue;
            var isValueRequired =
                inputName === "dateOfBirth"
                    ? $scope.data.beneficiaryDOBRequired
                    : $scope.data.isDateofTrustRequired;
            if (dateValue === "" && $scope.previousDateValue && isValueRequired) {
                beneficiary.dateOfBirth = $scope.previousDateValue;
                $scope.previousDateValue = null;
            }
        }
    };

    vm.touchUseAddressOnFile = function (event) {
        var method = "touchUseAddressOnFile()";
        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);
        $scope.focusInput(event);
    };

    vm.touchDOB = function (event) {
        var method = "touchDOB()";
        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);
    };

    vm.touchSSN = function (event) {
        var method = "touchSSN()";
        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);
    };

    vm.handleMaskSSN = function (beneficiary, event) {
        var method = "handleMaskSSN()";
        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);
        if (
            beneficiary &&
            beneficiaryService.getType(beneficiary) == vm.beneficiaryTypeCodes.Individual
        ) {
            var ssn = $scope.beneficiaryForm.socialSecurityNumber.$viewValue;

            if (ssn === "" && beneficiary.previousSSN && $scope.data.beneficiaryDOBRequired) {
                // The user cleared the SSN field and focused elsewhere. Restore the previous SSN value
                if (MaskUtil.isMasked(beneficiary.previousSSN)) {
                    // The previous value was a masked value (i.e. it was the value returned from PWS). Update
                    // socialSecurityNumber and clear newSSN because the value has been unchanged.
                    beneficiary.socialSecurityNumber = beneficiary.previousSSN;
                    beneficiary.newSSN = null;
                } else {
                    // The previous value was a user-entered (i.e. raw SSN) value, so we need to mask it before overriding socialSecurityNumber
                    beneficiary.socialSecurityNumber = MaskUtil.maskSSN(beneficiary.previousSSN);
                }
            }

            var validPattern = /^\d{3}-\d{2}-\d{4}/;
            if (validPattern.test(ssn)) {
                //make a copy and strip hyphens
                beneficiary.newSSN = ssn.replace(/-/g, "");
                beneficiary.socialSecurityNumber = MaskUtil.maskSSN(ssn);
            } else {
                logger.debug("{0} - ssn is not valid pattern", [method]);
            }
        } else {
            logger.debug("{0} - exiting handleMaskSSN...SKIPPING for non-Individual", [method]);
        }
    };

    vm.handleMaskTIN = function (beneficiary, event) {
        var method = "handleMaskTIN()";
        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);
        if (
            (beneficiary &&
                beneficiaryService.getType(beneficiary) == vm.beneficiaryTypeCodes.Trust) ||
            (beneficiary &&
                beneficiaryService.getType(beneficiary) == vm.beneficiaryTypeCodes.Other)
        ) {
            var ssn = $scope.beneficiaryForm.taxIdentificationNumber.$viewValue;
            if (ssn === "" && beneficiary.previousSSN && $scope.data.beneficiaryDOBRequired) {
                // The user cleared the SSN field and focused elsewhere. Restore the previous SSN value
                if (MaskUtil.isMasked(beneficiary.previousSSN)) {
                    // The previous value was a masked value (i.e. it was the value returned from PWS). Update
                    // socialSecurityNumber and clear newSSN because the value has been unchanged.
                    beneficiary.socialSecurityNumber = beneficiary.previousSSN;
                    beneficiary.newSSN = null;
                } else {
                    // The previous value was a user-entered (i.e. raw SSN) value, so we need to mask it before overriding socialSecurityNumber
                    beneficiary.socialSecurityNumber = MaskUtil.maskTIN(beneficiary.previousSSN);
                }
            }

            var validPattern = /^\d{2}-\d{3}\d{4}/;
            if (validPattern.test(ssn)) {
                //make a copy and strip hyphens
                beneficiary.newSSN = ssn.replace(/-/g, "");
                beneficiary.socialSecurityNumber = MaskUtil.maskTIN(ssn);
            } else {
                logger.debug("{0} - ssn is not valid pattern", [method]);
            }
        } else {
            logger.debug("{0} - exiting handleMaskSSN...SKIPPING for non-Trusted", [method]);
        }
    };

    /**
     *Toggle SSN from mask
     * (if SSN is masked and a non-navigation key is selected)
     */
    vm.toggleSSNfromMaskedKeyDown = function (beneficiary, event) {
        if (!vm.isNavigationKey(event.keyCode)) {
            if (vm.isSSNMasked(beneficiary)) {
                var charCode = String.fromCharCode(event.keyCode);
                // Save the previous value as the raw value in newSSN if available, otherwise save the current masked SSN
                beneficiary.previousSSN = beneficiary.newSSN
                    ? beneficiary.newSSN
                    : beneficiary.socialSecurityNumber;
                beneficiary.socialSecurityNumber = _.isNumber(charCode) ? charCode : "";
            }
        }
    };

    /**
     * returns true if the keycode is not a "navigation key"
     * http://keycode.info/
     * tab === 9
     * shift === 16 (ignore for 'shift+tab'
     * end, home, arrows === (35,40)
     */
    vm.isNavigationKey = function (keyCode) {
        var rc = keyCode && (keyCode === 9 || keyCode === 16 || (keyCode >= 35 && keyCode <= 40));
        //console.log('isNavigationKey keyCode=['+keyCode+'] rc=['+rc+']');
        return rc;
    };

    /**
     * Toggle SSN from mask..
     */
    vm.toggleSSNfromMaskedClick = function (beneficiary, event) {
        var method = "toggleSSNfromMaskedClick()";
        logger.debug("{0} - invoked.  event={1}", [method, event ? event.type : "undefined"]);
        if (!event) {
            logger.debug("{0} - no event.", [method]);
            return;
        }
        if (event.type === "touchend") {
            logger.debug("{0} - ignoring superfluous 'touchend'.", [method]);
            return;
        }
        $scope.focusInput(event);
        if ($scope.data.beneficiaryDOBRequired && vm.isSSNMasked(beneficiary)) {
            // Save the previous value as the raw value in newSSN if available, otherwise save the current masked SSN
            beneficiary.previousSSN = beneficiary.newSSN
                ? beneficiary.newSSN
                : beneficiary.socialSecurityNumber;
            beneficiary.socialSecurityNumber = "";
        }
    };

    vm.toggleRemoveBeneficiary = function (beneficiary) {
        // You will need to reallocate this percentage to another
        // Beneficiary(ies).
        var newState;

        switch (beneficiary.beneficiaryState) {
            case $scope.data.beneficiaryStates.default:
                newState = $scope.data.beneficiaryStates.flaggedForRemoval;
                break;

            case $scope.data.beneficiaryStates.flaggedForRemoval:
            case $scope.data.beneficiaryStates.removed:
                newState = $scope.data.beneficiaryStates.default;
                break;
        }

        vm.changeBeneficiaryState(beneficiary, beneficiary.beneficiaryState, newState);
    };

    vm.changeBeneficiaryState = function (beneficiary, oldState, newState) {
        var designation, i;

        beneficiary.beneficiaryState = newState;

        switch (beneficiary.beneficiaryDesignation) {
            case vm.beneficiaryDesignationCodes.Primary:
                designation = "Primary";
                break;

            case vm.beneficiaryDesignationCodes.Contingent:
                designation = "Contingent";
                break;
        }

        // Check if we are transitioning to or from the Removed state
        if (newState === beneficiaryActionStates.removed) {
            // Remove the beneficiary from the current designation
            i = vm.findBeneficiaryIndex(designation, beneficiary);

            if (i != -1) {
                $scope.data.beneficiaries[designation].splice(i, 1);
                //check to see if there is only 1 bene left in the specified designation and if so, change its allocation to 100
                if ($scope.data.beneficiaries[designation].length === 1) {
                    $scope.data.beneficiaries[designation][0].allocationPercent = 100;
                }
            }
        } else if (oldState === beneficiaryActionStates.removed) {
            // Add the beneficiary to the appropriate designation
            $scope.data.beneficiaries[designation].push(beneficiary);
        }
    };

    function processBeneficiaryData(beneficiary) {
        var valid = $scope.setFormFields(true);
        // If all the fields for the beneficiary are valid, we can
        // proceed
        if (valid) {
            // Check if the beneficiary in question is a new beneficiary
            // – i.e. it was added during this
            // session using the "Add new beneficiary" button.
            if (beneficiary.new) {
                // Set the allocation to 100% if this is the only
                // beneficiary of the current designation (and it is new
                // - i.e. not set)
                if (
                    ($scope.data.beneficiaries.Primary.length === 0 &&
                        beneficiary.beneficiaryDesignation ===
                            vm.beneficiaryDesignationCodes.Primary) ||
                    ($scope.data.beneficiaries.Contingent.length === 0 &&
                        beneficiary.beneficiaryDesignation ===
                            vm.beneficiaryDesignationCodes.Contingent)
                ) {
                    beneficiary.allocationPercent = 100;
                }

                vm.moveBeneficiaryDesignation(
                    beneficiary,
                    "New",
                    beneficiary.beneficiaryDesignation
                );
            } else {
                // Get the original record/state for this beneficiary so
                // we can see if the designation changed
                if (
                    beneficiary.hasOwnProperty("previousDesignation") &&
                    beneficiary.previousDesignation != beneficiary.beneficiaryDesignation
                ) {
                    vm.moveBeneficiaryDesignation(
                        beneficiary,
                        beneficiary.previousDesignation,
                        beneficiary.beneficiaryDesignation
                    );
                } else {
                    var designation = "Contingent";

                    if (
                        $scope.beneficiary.beneficiaryDesignation ===
                        vm.beneficiaryDesignationCodes.Primary
                    ) {
                        designation = "Primary";
                    }

                    beneficiary.name = beneficiaryService.getBeneficiaryName(beneficiary);

                    // Find the bene in the list and override it with
                    // the modified bene
                    var index = vm.findBeneficiaryIndex(designation, beneficiary);

                    if (index != -1) {
                        $scope.data.beneficiaries[designation][index] = _.assign({}, beneficiary);
                    } else {
                        $scope.data.beneficiaries[designation].push(beneficiary);
                    }
                }
            }
        }
    }
    /**
     * This function is executed when the primary action button within a
     * beneficiary field set is clicked. (i.e. "Done" or "Delete")
     *
     * @param beneficiary
     *            The beneficiary object
     * @param prefix
     *            A prefix to keep the field names and ids unique
     * @param index
     *            An index to keep the field names and ids unique
     */
    vm.beneficiaryAction = function (beneficiary) {
        vm.errors = [];

        switch (beneficiary.beneficiaryState) {
            case $scope.data.beneficiaryStates.default:
                var valid = $scope.setFormFields(true);

                //if the participant address is required
                if ($scope.data.beneficiaryAddressRequired === true) {
                    //if it is US or Canada we call the yellow box to validate the address
                    if (beneficiary.country.code === "US" || beneficiary.country.code === "CA") {
                        if (beneficiary.state === undefined || beneficiary.state === null) {
                            vm.errors.push(
                                $translate.instant(
                                    "app.beneficiary.bene.validationMessages.selectState"
                                )
                            );
                        } else {
                            processBeneficiaryData(beneficiary);
                            vm.submit($scope.beneficiaryForm.$valid);
                        }
                    } else {
                        ///other than us no validation required
                        processBeneficiaryData(beneficiary);
                        vm.submit($scope.beneficiaryForm.$valid);
                    }

                    // Validate the beneficiary
                } else {
                    //case were  participant address is not required
                    processBeneficiaryData(beneficiary);
                    vm.submit($scope.beneficiaryForm.$valid);
                }

                // If not valid then do nothing. The validation messages will
                // display inline with the
                // respective form fields.
                break;

            case $scope.data.beneficiaryStates.flaggedForRemoval:
                // Mark the beneficiary as "to be removed" and collapse the
                // fields
                vm.changeBeneficiaryState(
                    beneficiary,
                    $scope.data.beneficiaryStates.flaggedForRemoval,
                    $scope.data.beneficiaryStates.removed
                );
                eventBus.dispatch(beneficiaryPageEvents.EDIT_PAGE_DELETE, this);
                vm.submit(true);
                break;
        }
    };

    vm.getFormGroupClass = function (fieldName) {
        let state = formService.getFormGroupClass($scope.beneficiaryForm, fieldName);
        if (!vm.showMaritalStatErr && fieldName === "beneficiaryType") {
            state = "";
        }

        return state;
    };

    vm.isDirty = function (fieldName) {
        return formService.isDirty($scope.beneficiaryForm, fieldName);
    };

    vm.getFieldError = function (fieldName) {
        var response = formService.getFieldError($scope.beneficiaryForm, fieldName);

        vm.invalidSelection = false;
        if (response.beneInvalidRelationShip) {
            vm.invalidSelection = true;
        }

        return response;
    };

    vm.moveBeneficiaryDesignation = function (beneficiary, previousDesignation, newDesignation) {
        beneficiary.previousDesignation = newDesignation;

        switch (previousDesignation) {
            case "New":
                // Remove the new flag from the beneficiary object as it will no
                // longer be considered "new"
                delete beneficiary.new;

                break;

            case vm.beneficiaryDesignationCodes.Primary:
                // Remove the beneficiary from the Primary list
                vm.removeBeneficiaryFromList("Primary", beneficiary);
                break;

            case vm.beneficiaryDesignationCodes.Contingent:
                // Remove the beneficiary from the Contingent list
                vm.removeBeneficiaryFromList("Contingent", beneficiary);
                break;
        }

        beneficiary.name = beneficiaryService.getBeneficiaryName(beneficiary);

        // Check the selected designation for this beneficiary and move it
        if (newDesignation == vm.beneficiaryDesignationCodes.Primary) {
            $scope.data.beneficiaries.Primary.push(beneficiary);
        } else {
            $scope.data.beneficiaries.Contingent.push(beneficiary);
        }
    };

    vm.removeBeneficiaryFromList = function (designation, beneficiary) {
        var index = vm.findBeneficiaryIndex(designation, beneficiary);

        if (index != -1) {
            $scope.data.beneficiaries[designation].splice(index, 1);
            //check to see if there is only 1 bene left in the specified designation and if so, change its allocation to 100
            if ($scope.data.beneficiaries[designation].length === 1) {
                $scope.data.beneficiaries[designation][0].allocationPercent = 100;
            }
        }
    };

    vm.findBeneficiaryIndex = function (designation, beneficiary) {
        return _.findIndex($scope.data.beneficiaries[designation], {
            uniqueId: beneficiary.uniqueId
        });
    };

    vm.getMinimumDateOfBirth = function () {
        return DateUtil.getMinimumDateOfBirth();
    };

    vm.isDateOfBirthRequired = function () {
        return (
            $scope.data.beneficiaryDOBRequired &&
            beneficiaryService.getType($scope.beneficiary) === vm.beneficiaryTypeCodes.Individual
        );
    };

    vm.isSSNRequired = function () {
        return (
            $scope.data.beneficiarySSNRequired &&
            beneficiaryService.getType($scope.beneficiary) === vm.beneficiaryTypeCodes.Individual
        );
    };

    vm.isDateOfBirthDisabled = function () {
        return $scope.data.qjsaVerificationRequired;
    };

    vm.isTINRequired = function () {
        return false;
    };

    /**
     * Show the Marital Status section if the following conditions are met:
     *
     * 1. The plan is set up to show marital status.
     * 2. The current beneficiary is a Primary Beneficiary.
     * 3. The current beneficiary is the first Primary Beneficiary or there are
     *    no beneficiaries on file and the current beneficiary is defaulting to
     *    a Primary Beneficiary.
     */
    vm.showMaritalStatusSection = function () {
        var showMaritalStatusSection = false;

        // Only show Marital Status if the plan is set to display it
        if ($scope.data.showMaritalStatus) {
            // Only show Marital Status if this is a Primary Beneficiary
            if (
                $scope.beneficiary &&
                $scope.beneficiary.beneficiaryDesignation == vm.beneficiaryDesignationCodes.Primary
            ) {
                // Show Marital Status if this is the first Primary Beneficiary
                if (
                    $scope.data.beneficiaries.Primary.length > 0 &&
                    $scope.beneficiary.uniqueId === $scope.data.beneficiaries.Primary[0].uniqueId
                ) {
                    showMaritalStatusSection = true;
                } else if ($scope.data.beneficiaries.Primary.length === 0) {
                    // Show Marital Status if there are no beneficiaries on file and
                    // the current beneficiary is defaulting to a Primary Beneficiary.
                    showMaritalStatusSection = true;
                }
            }
        }

        return showMaritalStatusSection;
    };

    /**
     * Show the Designation section if ANY of the following conditions are met:
     *
     * 1. There is at least one Primary Beneficiary
     * 2. The current beneficiary is a Contingent Beneficiary
     */
    vm.showBeneficiaryDesignationSection = function () {
        var showBeneficiaryDesignationSection = false;

        // Show the Designation if there is at least one Primary Beneficiary
        if ($scope.data.beneficiaries.Primary.length > 0) {
            showBeneficiaryDesignationSection = true;
        } else if (
            $scope.beneficiary &&
            $scope.beneficiary.beneficiaryDesignation == vm.beneficiaryDesignationCodes.Contingent
        ) {
            // Show the Designation if the current beneficiary is a Contingent Beneficiary
            showBeneficiaryDesignationSection = true;
        }

        return showBeneficiaryDesignationSection;
    };

    /**
     * Show the Type section if the following conditions are met:
     *
     * 1. The current beneficiary is the first beneficiary that has defaulted to
     *    a Primary Beneficiary and we are either not displaying Marital Status
     *    based on plan settings or the participant has already selected the
     *    Marital Status.
     *
     *    AND
     *       We are not displaying Marital Status based on plan settings
     *       OR
     *       The participant has selected the Marital Status
     *
     * OR
     *
     * 2. There is at least one Primary Beneficiary on file and the participant
     *    has selected the Designation for the current beneficiary.
     *
     * OR
     *
     * 3. The current beneficiary is a Contingent Beneficiary.
     *
     * OR
     *
     * 4. The Marital Status is invalid.
     */
    vm.showBeneficiaryTypeSection = function () {
        var showBeneficiaryTypeSection = false;

        // Show the Type if this is the first beneficiary that has defaulted
        // to a Primary Beneficiary and we are either not displaying Marital
        // Status based on plan settings or the participant has already
        // selected the Marital Status.
        if ($scope.data.beneficiaries.Primary.length === 0) {
            // We are not displaying Marital Status based on plan settings
            if (!$scope.data.showMaritalStatus) {
                showBeneficiaryTypeSection = true;
            } else if (
                $scope.data.maritalStatus == vm.maritalStatuses.Married ||
                $scope.data.maritalStatus == vm.maritalStatuses.Single
            ) {
                // The participant has selected the Marital Status
                showBeneficiaryTypeSection = true;
            }
        } else if (
            $scope.data.beneficiaries.Primary.length > 0 &&
            $scope.beneficiary &&
            $scope.beneficiary.beneficiaryDesignation
        ) {
            // Show the Type if there is at least one Primary Beneficiary on file
            // and the participant has selected the Designation for the current
            // beneficiary.
            showBeneficiaryTypeSection = true;
        } else if (
            $scope.beneficiary &&
            $scope.beneficiary.beneficiaryDesignation == vm.beneficiaryDesignationCodes.Contingent
        ) {
            // Show the Type if the current beneficiary is a Contingent Beneficiary
            showBeneficiaryTypeSection = true;
        } else if (
            $scope.beneficiaryForm.maritalStatus &&
            $scope.beneficiaryForm.maritalStatus.$error.maritalStatusInvalid
        ) {
            // Show the Type if the Marital Status is invalid
            showBeneficiaryTypeSection = true;
        }

        return showBeneficiaryTypeSection;
    };

    /**
     * Show the main form section if the following conditions are met:
     *
     * 1. The current beneficiary already exists in the datbase.
     *
     * OR
     *
     * 2. The Beneficiary Type has been selected and we are not displaying the
     *    non-spousal beneficiary form message.
     */
    vm.showMainFormSection = function () {
        var showMainFormSection = false;

        // Show the main form section if the beneficiary is already on file (i.e. saved to the db)
        if ($scope.beneficiary && $scope.beneficiary.id) {
            showMainFormSection = true;
        } else if ($scope.beneficiary && $scope.beneficiary.beneficiaryType) {
            // Check if the Beneficiary Type has been selected
            showMainFormSection = true;
        }

        return showMainFormSection;
    };

    /**
     * Show the Cancel button if the following conditions are met:
     *
     *
     */
    vm.showCancelButton = function () {
        var showCancelButton = false;

        // Show the Cancel button if the beneficiary is already on file (i.e. saved to the db)
        if ($scope.beneficiary && $scope.beneficiary.id) {
            showCancelButton = true;
        } else if ($scope.data.beneficiaries.Primary.length > 0) {
            // Show the Cancel button if this is not the first primary beneficiary
            showCancelButton = true;
        } else if ($scope.beneficiary && $scope.beneficiary.beneficiaryLastName.length > 0) {
            // Show the Cancel button if there is beneficiary data (We won't
            // necessarily have an id if the beneficiary was added in this session,
            // but last name is required for all beneficiaries.)
            showCancelButton = true;
        } else if (
            $scope.data.qjsaVerificationRequired &&
            $scope.data.beneficiaries.Primary.length === 0 &&
            $scope.data.beneficiaries.Contingent.length === 0
        ) {
            // Show the Cancel button if there are no beneficiaries but QJSA
            // verification is required (they will see a message and not be able
            // to add beneficiaries, so we show the cancel button so they can
            // go back)
            showCancelButton = true;
        }

        return showCancelButton;
    };

    /**
     * simply return true if bene Update access is not enabled
     */
    vm.isViewOnly = function () {
        return beneficiaryService.getBeneAccessParams().beneUAccess === "false";
    };
    /**
     * Disable the maritalstatus button if  KTMG WNBMSU is on for the plan.
     */

    vm.disableMaritalStatus = function () {
        var beneAccess = beneficiaryService.getBeneAccessParams();
        var disableMaritalStatus = false;
        if (beneAccess.beneMAcess === "true") {
            disableMaritalStatus = true;
        }
        return disableMaritalStatus;
    };

    /**
     * Disable the Save button if any of the following conditions are met:
     *
     * 1. QJSA Verification is required
     *
     * OR
     *
     * 2. The form selection is invalid
     */
    vm.disableSaveButton = function () {
        var disableSaveButton = false;

        if ($scope.data.qjsaVerificationRequired) {
            disableSaveButton = true;
        } else if (vm.invalidSelection) {
            disableSaveButton = true;
        } else if (!$scope.data.maritalStatus) {
            disableSaveButton = true;
        } else {
            var beneAccess = beneficiaryService.getBeneAccessParams();
            if (beneAccess.beneUAccess == "false") {
                disableSaveButton = true;
            }
        }

        return disableSaveButton;
    };

    /**
     * Disable the delete checkbox if any of the following conditions are met:
     *
     * 1. QJSA Verification is required
     *
     * OR
     *
     * 2. KTMG WUBENE is not on for the plan.
     */
    vm.disableDelCheckBox = function () {
        var disableDelCheckBox = false;

        if ($scope.data.qjsaVerificationRequired) {
            disableDelCheckBox = true;
        } else {
            var beneAccess = beneficiaryService.getBeneAccessParams();
            if (beneAccess.beneUAccess == "false") {
                disableDelCheckBox = true;
            }
        }

        return disableDelCheckBox;
    };

    vm.getSubmitButtonClass = function (beneficiary, data) {
        if (beneficiary.beneficiaryState == data.beneficiaryStates.default) {
            return "btn-primary";
        } else {
            return "btn-danger";
        }
    };

    vm.removeInputFocus = function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    };

    vm.setInputFocus = function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    };

    vm.removeSaveErrors = function () {
        //If there are errors returned from the save, editing the bene will remove the errors
        var designation = "Contingent";
        if ($scope.beneficiary.beneficiaryDesignation === vm.beneficiaryDesignationCodes.Primary) {
            designation = "Primary";
        }
        var index = vm.findBeneficiaryIndex(designation, $scope.beneficiary);
        if (index != -1) {
            $scope.data.beneficiaries[designation][index].saveErrors = null;
        }
    };

    //If empty and required, set the country as US
    vm.setCountryIfMissing = function () {
        dataService.getBeneficiaryAddressRequired().then(function (beneficiaryAddressRequired) {
            var USIndex = _.findIndex($scope.data.countries, {
                code: "US",
                description: "United States"
            });

            if (
                beneficiaryAddressRequired &&
                $scope.beneficiary &&
                ($scope.beneficiary.country === undefined ||
                    $scope.beneficiary.country === null ||
                    $scope.beneficiary.country === "")
            ) {
                $scope.beneficiary.country = $scope.data.countries[USIndex];
            }
        });
    };
    vm.setCountryIfMissing();
}

BeneficiaryFormController.$inject = [
    "$scope",
    "$timeout",
    "beneficiaryService",
    "dataService",
    "formService",
    "$translate",
    "participantService",
    "eventBus"
];

export default BeneficiaryFormController;
